import React from 'react';
import { motion } from 'framer-motion';
import { GaugeIcon, MapIcon, ShieldIcon, ClipboardCheckIcon, BadgeCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const CAPABILITIES = [{
  icon: GaugeIcon,
  title: 'Water pressure diagnostics',
  desc: 'Finding the hidden reasons your zones aren\u2019t performing.'
}, {
  icon: MapIcon,
  title: 'Zone mapping & coverage engineering',
  desc: 'Making sure every inch of your property gets the right amount of water.'
}, {
  icon: ShieldIcon,
  title: 'Backflow prevention',
  desc: 'Protecting your home\u2019s water supply from contamination — legally required in Texas.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Code-compliant installation',
  desc: 'So your system passes inspection and your warranty stays intact.'
}];
export function LicensedSection() {
  return <section className="w-full bg-nfblue-dark py-16 text-white sm:py-24" data-id="element-214" data-mp="3cjbz800pxkai">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-215" data-mp="37ltl7v7ugevn">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-216" data-mp="274evztxvcig6">
          <div data-id="element-217" data-mp="2733s7u4fbap2">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide" data-id="element-218" data-mp="272lpcen99y86">
              <BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-219" data-mp="1y5beuvi9id4b" />
              Texas State License {SITE.license}
            </span>
            <h2 className="mt-5 font-display text-3xl font-extrabold sm:text-4xl" data-id="element-220" data-mp="22396s63f3dbe">
              What a licensed irrigator sees that others miss
            </h2>
            <p className="mt-4 text-lg text-slate-200" data-id="element-221" data-mp="2usptqo89q208">
              At {SITE.company}, that license represents certified training. When our
              team walks your property, we don't just look at what's broken — we look
              at what's failing silently, the things that will cost you money next
              month, and the month after.
            </p>
            <div className="mt-8 rounded-2xl border border-white/15 bg-white/5 p-6" data-id="element-222" data-mp="1aep6t489csub">
              <p className="font-display text-xl font-bold text-nfgreen-light" data-id="element-223" data-mp="3c3bt13j0igso">
                We don't just fix sprinklers. We solve lawns.
              </p>
              <p className="mt-2 text-slate-200" data-id="element-224" data-mp="374s54xkuyuxo">
                Northface was built for one purpose: to give North Texas homeowners
                and business owners a lawn and irrigation system they never have to
                think about again.
              </p>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-225" data-mp="2te58rc2klh4r">
            {CAPABILITIES.map((cap, i) => <motion.div key={cap.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="rounded-2xl border border-white/10 bg-white/5 p-6" data-id="element-226" data-mp="2oczbd0xyt5ow" data-mpi={i}>
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-nfgreen/20 text-nfgreen-light" data-id="element-227" data-mp="dm7m7u6fbjgs">
                  <cap.icon className="h-5 w-5" data-id="element-228" data-mp="1vh8d6estsk4t" />
                </div>
                <h3 className="mt-4 font-display text-lg font-bold" data-id="element-229" data-mp="20h4fm9lvk3i9">{cap.title}</h3>
                <p className="mt-1.5 text-sm text-slate-300" data-id="element-230" data-mp="25a70ltcl64mu">{cap.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}